<template>
  <div class="C-MobileNav">
    <el-collapse-transition>
      <div class="navbar-nav LeftNavBar transition-box content"  v-show="!left">
        <router-link to="/home" class="nav-link el-icon-s-home transition-box" @click.native="reset()"> 首页</router-link>
        <router-link to="/lists" class="nav-link el-icon-date transition-box" @click.native="reset()"> 信息</router-link>
        <router-link to="/merchant" class="nav-link el-icon-s-shop transition-box" @click.native="reset()"> 商家</router-link>
        <router-link to="/publish" class="nav-link el-icon-edit transition-box" @click.native="reset()"> 发布</router-link>
        <router-link to="/upgrade" class="nav-link el-icon-star-on transition-box" @click.native="reset()"> VIP升级</router-link>
        <router-link to="/help" class="nav-link el-icon-question transition-box" @click.native="reset()"> 帮助</router-link>
        <div class="nav-link transition-box">
        <search @reset="reset()"></search>
        </div>
      </div>
    </el-collapse-transition>
    <el-collapse-transition>
      <div class="navbar-nav LeftNavBar transition-box content" v-show="!right">
        <router-link to="/login" v-if="!$store.getters.Flag" class="nav-link el-icon-s-home transition-box " @click.native="reset()"> 登录</router-link>
        <router-link to="/registered" v-if="!$store.getters.Flag" class="nav-link el-icon-message-solid transition-box" @click.native="reset()"> 注册</router-link>
        <router-link to="/usercenter" v-if="$store.getters.Flag" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="user"></svg-icon> 会员中心</router-link>
        <router-link to="/publish" v-if="$store.getters.Flag" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="publish"></svg-icon> 信息发布</router-link>
        <router-link to="/myinfo" v-if="$store.getters.Flag" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="info"></svg-icon> 我的信息</router-link>
        <router-link to="/myfavorite" v-if="$store.getters.Flag" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="noheart"></svg-icon> 我的收藏</router-link>
        <router-link to="/upgrade" v-if="$store.getters.Flag" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="vip"></svg-icon> 升级vip</router-link>
        <router-link to="/editprofile" v-if="$store.getters.Flag" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="user-management"></svg-icon> 修改资料</router-link>
        <router-link to="/proxy" v-if="$store.getters.proxy" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="proxy"></svg-icon> 代理合作</router-link>
        <router-link to="/promote" v-if="$store.getters.promote" class="nav-link transition-box" @click.native="reset()"><svg-icon icon-class="proxy"></svg-icon> 推广送会员</router-link>
        <div v-if="this.$store.getters.Flag" style="cursor:pointer" class="nav-link" @click="out(), reset()">
          <svg-icon icon-class="exit"></svg-icon> 退出</div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import search from '../../widget/search'
import axios from 'axios'
export default {
  name: 'MobileNav',
  props: {
    left: {
      type: Boolean
    },
    right: {
      type: Boolean
    }
  },
  methods: {
    reset () {
      this.$emit('reset', 0)
    },
    out () {
      axios({
        url: '/api/out',
        methods: 'get'
      }).then(function (res) {
        if (res.data['status'] === 0) {
          localStorage.removeItem('promote')
          this.$store.commit('promote', localStorage.getItem('promote'))
          localStorage.removeItem('Flag')
          this.$store.commit('Flag', localStorage.getItem('Flag'))
          localStorage.removeItem('proxy')
          this.$store.commit('proxy', localStorage.getItem('proxy'))
          this.$message.success({
            message: '成功退出'
          })
          location.reload()
        }
      }.bind(this))
    }
  },
  components: {
    search
  }
}

</script>

<style scoped>
  .C-MobileNav {
    background-color: #fff;
    color: #666;
    position: fixed;
    width: 100%;
    z-index: 5!important;
    box-shadow: 0 1px 3px #d3d3d3;
    margin-top: 80px;
  }

  .navbar-nav {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    color: black;
    text-decoration: none;
  }

  .nav-link {
    font-size: 16px;
    word-break: keep-all;
    color: #666;
    text-decoration: none;
    padding: 12px 15px 12px 20px;
  }

  .LeftNavBar {
    text-align: left;
  }

  .active {
    color: #f39;
  }
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/header/MobileNav.vue